export default "__VITE_ASSET__BoKZqLe$__"